require('jquery')
require('bootstrap')
require('admin-lte/dist/js/adminlte')
